import BaseCache from './BaseCache'

// BaseCache에 실제로 저장되는 래퍼 형태를 타입으로 표현.
// key: 'email' 옵션에 맞춰 첫 번째 속성명을 email로 지정한다.
interface KnownSenderRecord {
  email: string
  data: boolean
  expireTime?: number | null
  isExpired: () => boolean
}

const knownSenderCache = new BaseCache<KnownSenderRecord>('knownSenderCache', {
  key: 'email',
  expireDuration: 60 * 1000, // 1분
  expireDurationForEmpty: null, // miss placeholder는 putData/clear로 소멸되므로 영구 유지 OK
})

export default knownSenderCache
